/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import React from 'react';

import { Cross } from '@zooplus/icons'; // Could be anything it is just to get types as it is not exposed by library by default

import styles from './Icon.module.scss';

type IconProps = {
    Icon: typeof Cross;
    className?: string;
    color: 'white' | 'primary' | 'secondary' | 'neutralDark' | 'error';
    aligned?: boolean;
    // Spread props
    [x: string]: any;
};

export function ThemedIcon({
    Icon,
    color,
    className,
    aligned,
    ...props
}: IconProps): JSX.Element {
    return (
        <Icon
            className={classNames(className, {
                [styles.iconWhite]: color === 'white',
                [styles.iconNeutralDark]: color === 'neutralDark',
                [styles.iconPrimary]: color === 'primary',
                [styles.iconSecondary]: color === 'secondary',
                [styles.iconError]: color === 'error',
                [styles.iconAligned]: aligned,
            })}
            {...props}
        />
    );
}
